export function UPDATE_EVENTS(state, data) {
  state.events = data
}

export function CLEAR_EVENTS(state) {
  state.events = []
}
